import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import axios from '../api/axiosInstance';

const BoilerModuleRoute = ({ children }) => {
  const [enabled, setEnabled] = useState(null);
  const [verificationError, setVerificationError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    const verifyLocation = async (locationId) => {
      setVerificationError(false);
      if (!locationId) {
        if (mounted) setEnabled(false);
        return;
      }

      try {
        const response = await axios.get(`/api/locations/${locationId}`);
        if (mounted) {
          const isEnabled = Boolean(response.data?.boilerModuleEnabled);
          sessionStorage.setItem('selectedLocationBoilerModuleEnabled', String(isEnabled));
          setEnabled(isEnabled);
        }
      } catch (error) {
        if (mounted) {
          setEnabled(null);
          setVerificationError(true);
        }
      }
    };

    verifyLocation(sessionStorage.getItem('selectedLocationId'));

    const handleLocationContextChanged = (event) => {
      verifyLocation(event.detail?.locationId);
    };
    window.addEventListener('odin:location-context-changed', handleLocationContextChanged);

    return () => {
      mounted = false;
      window.removeEventListener('odin:location-context-changed', handleLocationContextChanged);
    };
  }, [retryCount]);

  if (verificationError) {
    return (
      <main className="boiler-module-route-error" role="alert">
        <h1>Unable to verify Boiler Matrix access</h1>
        <p>ODIN could not confirm the selected location’s module access. Check the connection and try again.</p>
        <div>
          <button type="button" onClick={() => setRetryCount((count) => count + 1)}>Try again</button>
          <button type="button" onClick={() => navigate('/dashboard')}>Back to dashboard</button>
        </div>
      </main>
    );
  }
  if (enabled === null) return null;
  if (!enabled) return <Navigate to="/dashboard" replace />;
  return children;
};

export default BoilerModuleRoute;
